<style lang="scss" scoped>
.tooltip {
  position: relative;
  width: 30px;
  line-height: 1.6;
  background: var(--gray-light);
  border: 1px solid var(--gray-light);
  border-radius: 3px;
  cursor: pointer;
  transition: border 0.2s;
  &:hover {
    border: 1px solid var(--gray);
  }
  .tooltip-popover {
    position: absolute;
    top: 17px;
    left: -110px;
    width: 250px;
    padding: 15px;
    background: #fff;
    border-radius: 3px;
    border: 1px solid var(--border-color);
    z-index: 10;
    font-size: 14px;
  }
}
</style>

<template>
    <div v-if="totalNapTime > 0" class="tooltip" @click="open = !open" v-click-outside="() => { open = false }">
        {{ totalNapTime }}m
        <div v-if="open" class="tooltip-popover">
            <div v-for="(nap,index) in naps" :key="index" class="d-flex text-left mb-8">
                <p class="mx-auto">[{{index+1}}] {{ nap.start_time }} - {{ nap.end_time }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {

    props: {
        naps: {
            type: Array,
            default: () => [],
        }
    },

    data() {
        return {
            open: false
        }
    },

    computed: {
        totalNapTime() {
            return this.naps.reduce((totalTime, nap) => {
                const startOfDay = this.$moment().startOf('day')
                const endTime = startOfDay.clone().add(this.$moment.duration(nap.end_time).asMilliseconds(), 'milliseconds')
                const startTime = startOfDay.clone().add(this.$moment.duration(nap.start_time).asMilliseconds(), 'milliseconds')
                if(startTime >= endTime) {
                    startTime.add(1, 'days')
                }
                return totalTime + endTime.diff(startTime, 'minutes', true)
            }, 0)
        },
    },

    directives: {
        ClickOutside
    },

}
</script>